import { render, staticRenderFns } from "./OppByDepts.vue?vue&type=template&id=00983ee0&scoped=true&"
import script from "./OppByDepts.vue?vue&type=script&lang=js&"
export * from "./OppByDepts.vue?vue&type=script&lang=js&"
import style0 from "./OppByDepts.vue?vue&type=style&index=0&id=00983ee0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00983ee0",
  null
  
)

export default component.exports